// extracted by mini-css-extract-plugin
export default {"wrapper":"fGJmD7","header":"mGGhGx","ok-button":"Gxe3CC","okButton":"Gxe3CC","sub-footer":"M8lMgB","subFooter":"M8lMgB"};